import React from 'react';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import {format} from 'date-fns';
import {useSelector} from "react-redux";

const fdd = (date) => {
    let dt = date.split("-");
    const nd = new Date(dt[0], (dt[1] - 1), dt[2]);
    return format(nd, 'MMMM d, yyyy');
};
const TripInfo = () => {
    const {data: trip} = useSelector(state => state.trip);
    const boardNotes = trip.boardNotes || `Meeting in ${trip && 'depart' in trip && trip['depart']} at ${trip && 'boardtime' in trip && trip['boardtime']} on ${trip && 'boarddate' in trip && fdd(trip['boarddate'])}`;
    const disembarkNotes = trip.disembarkNotes || `Returning to ${trip && 'arrive' in trip && trip['arrive']} on ${trip && 'returndate' in trip && fdd(trip['returndate'])} at ${trip && 'returntime' in trip && trip['returntime']}`;
    
    return (
        <div>
            {trip && Object.keys(trip).length > 0 && <Container maxWidth="lg" className={'tripInfoDetails'}>
                <Typography variant="h2" component="h2" className={'tripTitle'}>
                    {trip['shortcomment']}
                </Typography>
                <Typography variant="body1" component="p" className={'tripDescription'}>
                    <span dangerouslySetInnerHTML={{__html: trip['comment']}}/>
                </Typography>
                <Typography variant="body1" component="p" className={'tripDates'}>
                    {boardNotes}
                    <br/>
                    {disembarkNotes}
                </Typography>
            </Container>}
        </div>
    );
};

export default TripInfo;
